<template>
  <div>
    <img src="@/assets/logo.png"
         alt=""
         class="logo" />
    <a-menu mode="inline"
            theme="dark"
            :inlineCollapsed="collapsed"
            class="menu"
            :selectedKeys="[$route.path]"
            @select="clickMenu"
            :openKeys="openKeys"
            @openChange="onOpenChange">
      <template v-for="item in list">
        <a-menu-item v-if="!item.children"
                     :key="item.key"
                     class="menu-item">
          <div class="item-box">
            <img :src="item.icon"
                 alt="" /><span>{{ item.title }}</span>
          </div>
        </a-menu-item>
        <sub-menu v-else
                  :menu-info="item"
                  :key="item.key" />
      </template>
    </a-menu>
  </div>
</template>

<script>
import SubMenu from './SubMenu'
export default {
  name: 'LeftMenu',
  components: {
    SubMenu
  },
  mounted () {
    this.defautOpenKey()
  },
  data () {
    return {
      collapsed: false,
      list: [
        {
          key: '/institution',
          title: '机构管理',
          icon: require('@/assets/园区管理.png')
        },
        {
          key: '/access-control',
          title: '门禁设备管理',
          icon: require('@/assets/门禁设备管理.png'),
          children: [
            {
              key: '/access-control',
              title: '门禁设备'
            }
          ]
        },
        {
          key: '/door-plate-equipment',
          title: '门牌设备管理',
          icon: require('@/assets/门禁设备管理.png')
        },
        {
          key: '/handle',
          title: '手持设备管理',
          icon: require('@/assets/门禁设备管理.png'),
          children: [
            {
              key: '/handle-control',
              title: '手持设备'
            }
          ]
        },
        {
          key: '/collection-equipment',
          title: '访客设备管理',
          icon: require('@/assets/访客设备管理.png')
        },
        {
          key: '/pay-equipment',
          title: '支付设备管理',
          icon: require('@/assets/支付设备管理.png')
        },
        {
          key: '/node-equipment',
          title: '节点设备管理',
          icon: require('@/assets/节点设备管理.png')
        },
        {
          key: '/screen-equipment',
          title: '屏显设备管理',
          icon: require('@/assets/屏显设备管理.png')
        },
        {
          key: '/version',
          title: '固件版本',
          icon: require('@/assets/固件版本.png'),
          children: [
            {
              key: '/version/management',
              title: '版本管理'
            }
          ]
        },
        {
          key: '/system',
          title: '系统管理',
          icon: require('@/assets/系统管理.png'),
          children: [
            {
              key: '/system/account',
              title: '账号管理'
            }
          ]
        }
      ],
      openKeys: []
    }
  },
  computed: {
    rootSubmenuKeys () {
      let keys = this.list.map((item) => {
        if (item.children && item.children.length > 0) {
          return item.key
        }
      })
      return keys
    }
  },
  methods: {
    // 刷新页面展开选中菜单
    defautOpenKey () {
      let path
      let paths = this.$route.path.split('/')
      if (paths.length >= 3) {
        path = paths[paths.length - 2]
      }
      this.openKeys = ['/' + path]
    },

    // 点击菜单
    clickMenu ({ key }) {
      this.$router.push(key)
    },

    // 打开一级菜单
    onOpenChange (openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      )
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.logo {
  width: 184px;
  height: 60px;
}
.menu {
  // padding-top: 64px;
  .menu-item {
    text-align: left;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    .item-box {
      line-height: 50px;
      display: flex;
      align-items: center;
      img {
        height: 14px;
        width: 14px;
        margin-right: 8px;
      }
    }
  }
}
</style>
